export const contactButtonText = {
    ru: "Связаться с нами",
    en: "Contact Us",
    kz: "Сізге хабарласыңыз",
}